import { render, staticRenderFns } from "./ConsignmentDes.vue?vue&type=template&id=0cd8ba1b&scoped=true&"
import script from "./ConsignmentDes.vue?vue&type=script&lang=js&"
export * from "./ConsignmentDes.vue?vue&type=script&lang=js&"
import style0 from "./ConsignmentDes.vue?vue&type=style&index=0&id=0cd8ba1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd8ba1b",
  null
  
)

export default component.exports